<template>
    <div class="sustainable-component admin-analysis-criteras">
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <CommonLabelContainer title="Ändra kriterier" class="mt-5 mb-3">
                        <div class="container-fluid">
                            <div class="row">
                                <!-- Criteria 1 -->
                                <div class="col-12 col-md-6">
                                    <v-text-field bg-color="white"
                                                  type="text"
                                                  label="Kriteria 1 namn"
                                                  variant="outlined"
                                                  v-model="analysisCriteria1.Name"
                                                  autofocus />

                                    <v-checkbox density="compact"
                                                v-model="analysisCriteria1.Active"
                                                label="Aktiv"
                                                hide-details />

                                    <div class="d-flex align-center ga-2 mb-2">
                                        <v-text-field bg-color="white"
                                                      variant="outlined"
                                                      label="Lägg till värde"
                                                      v-model="newValue1"
                                                      hide-details
                                                      @keyup.enter="addValue(1)" />
                                        <v-btn variant="tonal" class="bg-primary" @click="addValue(1)">
                                            Lägg till
                                        </v-btn>
                                    </div>

                                    <div v-if="criteria1Values.length === 0" class="text-medium-emphasis">
                                        Inga värden än.
                                    </div>

                                    <div class="d-flex flex-wrap ga-2">
                                        <v-chip v-for="(val, i) in criteria1Values"
                                                :key="'c1-' + i"
                                                closable
                                                @click="startEdit(1, i)"
                                                @click:close="removeValue(1, i)">
                                            {{ val }}
                                        </v-chip>
                                    </div>

                                    <v-dialog v-model="editDialog1" max-width="520">
                                        <v-card>
                                            <v-card-title>Redigera värde</v-card-title>
                                            <v-card-text>
                                                <v-text-field bg-color="white"
                                                              variant="outlined"
                                                              label="Värde"
                                                              v-model="editValue1"
                                                              @keyup.enter="saveEdit(1)" />
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer />
                                                <v-btn variant="text" @click="cancelEdit(1)">Avbryt</v-btn>
                                                <v-btn class="bg-primary" variant="tonal" @click="saveEdit(1)">Spara</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>

                                <!-- Criteria 2 -->
                                <div class="col-12 col-md-6">
                                    <v-text-field bg-color="white"
                                                  type="text"
                                                  label="Kriteria 2 namn"
                                                  variant="outlined"
                                                  v-model="analysisCriteria2.Name" />

                                    <v-checkbox density="compact"
                                                v-model="analysisCriteria2.Active"
                                                label="Aktiv"
                                                hide-details />

                                    <div class="d-flex align-center ga-2 mb-2">
                                        <v-text-field bg-color="white"
                                                      variant="outlined"
                                                      label="Lägg till värde"
                                                      v-model="newValue2"
                                                      hide-details
                                                      @keyup.enter="addValue(2)" />
                                        <v-btn variant="tonal" class="bg-primary" @click="addValue(2)">
                                            Lägg till
                                        </v-btn>
                                    </div>

                                    <div v-if="criteria2Values.length === 0" class="text-medium-emphasis">
                                        Inga värden än.
                                    </div>

                                    <div class="d-flex flex-wrap ga-2">
                                        <v-chip v-for="(val, i) in criteria2Values"
                                                :key="'c2-' + i"
                                                closable
                                                @click="startEdit(2, i)"
                                                @click:close="removeValue(2, i)">
                                            {{ val }}
                                        </v-chip>
                                    </div>

                                    <v-dialog v-model="editDialog2" max-width="520">
                                        <v-card>
                                            <v-card-title>Redigera värde</v-card-title>
                                            <v-card-text>
                                                <v-text-field bg-color="white"
                                                              variant="outlined"
                                                              label="Värde"
                                                              v-model="editValue2"
                                                              @keyup.enter="saveEdit(2)" />
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer />
                                                <v-btn variant="text" @click="cancelEdit(2)">Avbryt</v-btn>
                                                <v-btn class="bg-primary" variant="tonal" @click="saveEdit(2)">Spara</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12 col-md-6">
                                    <v-btn variant="tonal" class="bg-primary" @click="updateAnalysisCriterias">
                                        Spara
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>
            </div>
        </div>

        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{ snackbarMessage }}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{ errorMessage }}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import CommonSpinner from "../../common/common-spinner.vue";

    export default {
        name: "admin-analysis-criteras",
        components: { CommonLabelContainer, CommonSpinner },

        data() {
            return {
                analysisCriteria1: { Name: "", Content: "", Active: false },
                analysisCriteria2: { Name: "", Content: "", Active: false },

                // UI state
                newValue1: "",
                newValue2: "",

                editDialog1: false,
                editDialog2: false,
                editIndex1: -1,
                editIndex2: -1,
                editValue1: "",
                editValue2: "",

                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },

        computed: {
            criteria1Values() {
                return this.parseContentToList(this.analysisCriteria1.Content);
            },
            criteria2Values() {
                return this.parseContentToList(this.analysisCriteria2.Content);
            },
        },

        methods: {
            parseContentToList(content) {
                // Antag att ni sparar som rad-separerat idag (textarea).
                // Robust: tillåt även kommatecken/semikolon som fallback.
                if (!content) return [];
                return String(content)
                    .split(/\r?\n|;|,/g)
                    .map((x) => x.trim())
                    .filter((x) => x.length > 0);
            },

            serializeListToContent(list) {
                // Spara på samma “textarea”-sätt: en rad per värde.
                return (list || []).map((x) => x.trim()).filter(Boolean).join("\n");
            },

            setCriteriaList(which, newList) {
                const unique = [];
                const seen = new Set();

                for (const raw of newList) {
                    const v = String(raw ?? "").trim();
                    if (!v) continue;
                    const key = v.toLowerCase(); // mild dedupe (case-insensitive)
                    if (seen.has(key)) continue;
                    seen.add(key);
                    unique.push(v);
                }

                const content = this.serializeListToContent(unique);

                if (which === 1) this.analysisCriteria1.Content = content;
                else this.analysisCriteria2.Content = content;
            },

            addValue(which) {
                const input = which === 1 ? this.newValue1 : this.newValue2;
                const v = String(input ?? "").trim();
                if (!v) return;

                const list = which === 1 ? [...this.criteria1Values] : [...this.criteria2Values];
                list.push(v);
                this.setCriteriaList(which, list);

                if (which === 1) this.newValue1 = "";
                else this.newValue2 = "";
            },

            removeValue(which, index) {
                const list = which === 1 ? [...this.criteria1Values] : [...this.criteria2Values];
                list.splice(index, 1);
                this.setCriteriaList(which, list);
            },

            startEdit(which, index) {
                const list = which === 1 ? this.criteria1Values : this.criteria2Values;
                const current = list[index] ?? "";

                if (which === 1) {
                    this.editIndex1 = index;
                    this.editValue1 = current;
                    this.editDialog1 = true;
                } else {
                    this.editIndex2 = index;
                    this.editValue2 = current;
                    this.editDialog2 = true;
                }
            },

            saveEdit(which) {
                if (which === 1) {
                    const v = String(this.editValue1 ?? "").trim();
                    if (!v) return; // eller ta bort istället om tomt
                    const list = [...this.criteria1Values];
                    if (this.editIndex1 >= 0) list[this.editIndex1] = v;
                    this.setCriteriaList(1, list);
                    this.cancelEdit(1);
                } else {
                    const v = String(this.editValue2 ?? "").trim();
                    if (!v) return;
                    const list = [...this.criteria2Values];
                    if (this.editIndex2 >= 0) list[this.editIndex2] = v;
                    this.setCriteriaList(2, list);
                    this.cancelEdit(2);
                }
            },

            cancelEdit(which) {
                if (which === 1) {
                    this.editDialog1 = false;
                    this.editIndex1 = -1;
                    this.editValue1 = "";
                } else {
                    this.editDialog2 = false;
                    this.editIndex2 = -1;
                    this.editValue2 = "";
                }
            },

            async getAnalysisCriteria() {
                this.loading++;
                try {
                    const analysisCriterias = await AdminService.getAnalysisCriterias();
                    this.analysisCriteria1 = analysisCriterias.Criteria1;
                    this.analysisCriteria2 = analysisCriterias.Criteria2;
                } finally {
                    this.loading--;
                }
            },

            async updateAnalysisCriterias() {
                this.loading++;
                try {
                    const analysisCriterias = {
                        Criteria1: this.analysisCriteria1,
                        Criteria2: this.analysisCriteria2,
                    };
                    await AdminService.updateAnalysisCriterias(analysisCriterias);
                    this.displaySnackBar("Analyskriterierna uppdaterades");
                } catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat");
                } finally {
                    this.loading--;
                }
            },

            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        mounted() {
            this.getAnalysisCriteria();
        },
    };
</script>


<style scoped>
</style>
